<template>
  <div class="container">
    <form class="form" @submit.prevent="submitForm">
        <div class="field">
          <input class="input" v-model="name" type="text" placeholder="NAME" required />
          <span class="floating-label">NAME</span>
        </div>
      <div class="field">
        <input class="input" v-model="email" type="email" placeholder="EMAIL" required />
        <span class="floating-label">EMAIL</span>
      </div>
      <div class="field">
        <input class="input" v-model="subject" type="text" placeholder="SUBJECT" required />
        <span class="floating-label">SUBJECT</span>
      </div>
      <div class="field">
        <textarea class="textarea" v-model="message" placeholder="MESSAGE" required></textarea>
        <span class="floating-label">MESSAGE</span>
      </div>
    <button type="submit" class="submit-btn">SEND</button>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const JAW_EMAIL_URL = process.env.VUE_APP_JAW_EMAIL_URL;
const JAW_RECIPIENT_EMAIL = process.env.VUE_APP_JAW_RECIPIENT_EMAIL;
const JAW_SENDER_EMAIL = process.env.VUE_APP_JAW_SENDER_EMAIL;
 
const name = ref('')
const email = ref('')
const subject = ref('')
const message = ref('')

const submitForm = async () => {
  const payload = {
    recipientEmail: JAW_RECIPIENT_EMAIL,
    subject: `${subject.value}`,
    message: `${message.value}` + `Sent from ${email.value}`,
    senderEmail: JAW_SENDER_EMAIL,
  }

  try {
    const res = await fetch(JAW_EMAIL_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })

    const result = await res.json()
    if (res.ok) {
      name.value = ''
      email.value = ''
      subject.value = ''
      message.value = ''
      console.log(`Email sent succesfully,`, res )

    } else {
      console.log(`Error: ${result.error || 'Failed to send message'}`)
    }
  } catch (err) {
    console.log(`Unexpected error: ${err.message}`)
  }
}
</script>

<style scoped>
.container {
  width: 303px;
  height: 593px;
  background-color: #222762;
  padding: 1rem;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
}

.field {
  position: relative;
}

.floating-label {
  display: none;
}

.input {
  width: 243px;
  height: 51px;
  font-size: 14px;
  outline: none;
  margin-bottom: 40px;
  padding-left: 10px;
}

.input:focus {
  border-color: #00FF0C;
  border-width: 2px;
}

.input::placeholder {
  color: black;
}

.textarea {
  width: 243px;
  height: 120px;
  background-color: #f5f9fd;
  margin-bottom: 33px;
  
  padding-top: 10px;
  padding-left: 10px;
  color: #000;
  font-size: 14px;
  border: none;
  outline: none;
}

.textarea::placeholder {
  color: black;
  padding-left: 10px;
}

.submit-btn {
  width: 82px;
  height: 40px;
  background-color: #00FF0C;
  color: #000;
  border: none;
  padding: 0.75rem 0;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.submit-btn:hover {
  background-color: #00e600;
}

@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .container {
    width: 650px;
    height: 750px;
  }

  .input {
    width: 475px;
    height: 66px;
    font-size: 22px;
    position: relative;
  }

  .floating-label {
    display: block;
    position: absolute;
    left: 12px;
    top: 20px;
    font-size: 22px;
    color: black;
    transition: all 0.2s ease-out;
    pointer-events: none;
    background: white;
    padding: 0 4px;
  }

  .input:focus + .floating-label,
  .input:not(:placeholder-shown) + .floating-label,
  .textarea:focus + .floating-label,
  .textarea:not(:placeholder-shown) + .floating-label {
    top: -10px;
    font-size: 14px;
    color: black;
  }

  .input::placeholder,
  .textarea::placeholder {
    color: transparent;
  }

  .textarea {
    width: 475px;
    height: 235px;
    font-size: 22px;
  }

  .submit-btn {
    width: 201px;
    height: 66px;
    font-size: 22px;
  }
}

@media (min-width: 1280px) {
}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .container {
    width: 742px;
    height: 820px;
  }

  .input {
    width: 595px;
    height: 66px;
    font-size: 24px;
  }

  .textarea {
    width: 595px;
    height: 235px;
    font-size: 24px;
  }

  .submit-btn {
    width: 201px;
    height: 66px;
    font-size: 24px;
  }
}
</style>